import(/* webpackMode: "eager" */ "/vercel/path0/api-client/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Box/reset.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Box/useBoxStyles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Footer/footer.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["SiteProvider"] */ "/vercel/path0/components/SiteProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmbeddedProvider"] */ "/vercel/path0/hooks/embedded.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
